import React from 'react';
import ReactTooltip from 'react-tooltip';

import styles from '../../styles/views/components/Tooltip.module.scss';

const Tooltip = () => (
  <ReactTooltip
    className={styles.custom}
    place="bottom"
    effect="solid"
    backgroundColor="#545353"
    textColor="#FFFFFF"
  />
);

export default Tooltip;
